import { util } from '@/api/util';
import { getContactLabel } from './common';
export const transformNewUnit2EntityOrg = (item, options) => {
    var _a, _b, _c, _d;
    const { lastUpdateTime, idRewriteMap, assocRootIds } = options;
    const orgName = item.name || '';
    const orgPYName = util.toPinyin(orgName);
    const isMainRoot = item.pid == null || item.pid === '';
    const isAssocRoot = (_a = assocRootIds === null || assocRootIds === void 0 ? void 0 : assocRootIds.has(item.id)) !== null && _a !== void 0 ? _a : false;
    let id = (_b = idRewriteMap === null || idRewriteMap === void 0 ? void 0 : idRewriteMap.get(item.id)) !== null && _b !== void 0 ? _b : item.id;
    let parent = (_d = (_c = idRewriteMap === null || idRewriteMap === void 0 ? void 0 : idRewriteMap.get(item.pid)) !== null && _c !== void 0 ? _c : item.pid) !== null && _d !== void 0 ? _d : '';
    let type = item.type;
    let originId = item.qyId;
    if (isMainRoot) {
        id = '-1';
        parent = '-2';
        type = 99;
        originId = 'org_' + item.orgId;
    }
    else if (isAssocRoot) {
        id = `${item.orgId}_-1`;
        parent = '-2';
        originId = 'org_' + item.orgId;
    }
    return {
        id,
        parent,
        orgName,
        orgPYName,
        rank: item.rank,
        orgRank: item.rank,
        type,
        originId,
        enterpriseId: item.orgId,
        _lastUpdateTime: lastUpdateTime,
        orgLabel: '',
    };
};
export const transformNewContact2EntityContact = (item, options) => {
    var _a, _b;
    const { lastUpdateTime, idPathMap } = options;
    const email = (item.email || '').toLocaleLowerCase();
    const displayEmail = (item.displayEmail || item.email || '').toLocaleLowerCase();
    const name = item.name || '';
    const pinyinChars = name.split('').map((char) => util.toPinyin(char));
    const contactPYName = pinyinChars.join('');
    const contactPYLabelName = pinyinChars.map(py => py.slice(0, 1).toLocaleLowerCase()).join('');
    return {
        id: item.id,
        accountOriginId: item.id,
        accountName: email,
        displayEmail,
        contactName: name,
        contactPYName,
        contactPYLabelName,
        contactLabel: getContactLabel(contactPYName),
        enterpriseId: item.orgId,
        type: 'enterprise',
        enableIM: true,
        _lastUpdateTime: lastUpdateTime,
        updateTime: new Date(lastUpdateTime),
        avatar: '',
        avatarPendant: '',
        position: (_a = item.unitNames) !== null && _a !== void 0 ? _a : (idPathMap && Array.isArray(item.unitInfos) ? item.unitInfos.map(u => idPathMap.get(u.id)).filter((p) => !!p) : []),
        visibleCode: 0,
        accountVisible: 0,
        accountStatus: (_b = item.status) !== null && _b !== void 0 ? _b : 0,
        accountType: item.type,
        job: item.job || '',
    };
};
export const transformNewContact2EntityContactItem = (item, options) => {
    const { lastUpdateTime } = options;
    const _email = (item.email || '').toLocaleLowerCase();
    const _displayEmail = (item.displayEmail || '').toLocaleLowerCase();
    const allEmails = [...new Set([_displayEmail, _email].filter(e => e && e.trim().length > 0))];
    const itemList = allEmails.map((emailVal, index) => ({
        id: util.getUnique(item.id, 'EMAIL', emailVal),
        contactItemVal: emailVal,
        contactItemRefer: '',
        contactItemType: 'EMAIL',
        emailType: index === 0 ? -1 : 1,
        isDefault: index === 0 ? 1 : 0,
        contactId: item.id,
        type: 'enterprise',
        enterpriseId: item.orgId,
        _lastUpdateTime: lastUpdateTime,
        updateTime: lastUpdateTime,
    }));
    if (item.mobile && item.mobile.trim()) {
        itemList.push({
            id: util.getUnique(item.id, 'MOBILE', item.mobile),
            contactItemVal: item.mobile.trim(),
            contactItemRefer: '',
            contactItemType: 'MOBILE',
            emailType: 0,
            isDefault: 0,
            contactId: item.id,
            type: 'enterprise',
            enterpriseId: item.orgId,
            _lastUpdateTime: lastUpdateTime,
            updateTime: lastUpdateTime,
        });
    }
    if (item.tel && item.tel.trim()) {
        itemList.push({
            id: util.getUnique(item.id, 'TEL', item.tel),
            contactItemVal: item.tel.trim(),
            contactItemRefer: '',
            contactItemType: 'TEL',
            emailType: 0,
            isDefault: 0,
            contactId: item.id,
            type: 'enterprise',
            enterpriseId: item.orgId,
            _lastUpdateTime: lastUpdateTime,
            updateTime: lastUpdateTime,
        });
    }
    return itemList;
};
export const transformNewContact2EntityOrgContact = (item, options) => {
    const { lastUpdateTime } = options;
    if (!Array.isArray(item.unitInfos) || !item.unitInfos.length) {
        return [];
    }
    return item.unitInfos
        .filter(u => u && u.id)
        .map(u => {
        var _a;
        return ({
            id: util.getUnique(u.id, item.id),
            orgId: u.id,
            contactId: item.id,
            rankNum: (_a = u.arank) !== null && _a !== void 0 ? _a : 0,
            type: 'enterprise',
            enterpriseId: item.orgId,
            _lastUpdateTime: lastUpdateTime,
        });
    });
};
export const transformNewContact2EntityOrgContactForOrgId = (item, targetOrgId, options) => {
    var _a;
    const { lastUpdateTime } = options;
    if (!Array.isArray(item.unitInfos)) {
        return null;
    }
    const matched = item.unitInfos.find(u => u && u.id === targetOrgId);
    if (!matched) {
        return null;
    }
    return {
        id: util.getUnique(targetOrgId, item.id),
        orgId: targetOrgId,
        contactId: item.id,
        rankNum: (_a = matched.arank) !== null && _a !== void 0 ? _a : 0,
        type: 'enterprise',
        enterpriseId: item.orgId,
        _lastUpdateTime: lastUpdateTime,
    };
};
export const transformNewContactListForOrgId = (list, targetOrgId, options) => {
    const contacts = [];
    const contactItems = [];
    const orgContacts = [];
    list.forEach(item => {
        contacts.push(transformNewContact2EntityContact(item, options));
        transformNewContact2EntityContactItem(item, options).forEach(ci => contactItems.push(ci));
        const oc = transformNewContact2EntityOrgContactForOrgId(item, targetOrgId, options);
        if (oc) {
            orgContacts.push(oc);
        }
    });
    return { contacts, contactItems, orgContacts };
};
export const aggregateNewContacts = (rawList) => {
    const map = new Map();
    for (const raw of rawList) {
        if (!raw.unitInfo || !raw.unitInfo.id) {
            console.error('[aggregateNewContacts] skipping record with null/empty unitInfo, id=', raw.id);
            continue;
        }
        const existing = map.get(raw.id);
        if (existing) {
            existing.unitInfos.push(raw.unitInfo);
            existing.qyUnitIds.push(raw.qyUnitId);
        }
        else {
            map.set(raw.id, {
                base: raw,
                unitInfos: [raw.unitInfo],
                qyUnitIds: [raw.qyUnitId],
            });
        }
    }
    const result = [];
    for (const { base, unitInfos, qyUnitIds } of map.values()) {
        result.push({
            id: base.id,
            name: base.name,
            email: base.email,
            displayEmail: base.displayEmail,
            type: base.type,
            orgId: base.orgId,
            unitInfos,
            qyUnitIds,
            unitNames: base.unitNames,
            job: base.job,
            mobile: base.mobile,
            gender: base.gender,
            state: base.state,
            status: base.status,
            tel: base.tel,
        });
    }
    return result;
};
export const transformNewContactListForOrgIds = (list, targetOrgIds, options) => {
    const contacts = [];
    const contactItems = [];
    const orgContacts = [];
    list.forEach(item => {
        contacts.push(transformNewContact2EntityContact(item, options));
        transformNewContact2EntityContactItem(item, options).forEach(ci => contactItems.push(ci));
        if (Array.isArray(item.unitInfos)) {
            item.unitInfos
                .filter(u => u && u.id && targetOrgIds.has(u.id))
                .forEach(u => {
                var _a;
                const { lastUpdateTime } = options;
                orgContacts.push({
                    id: `${u.id}_${item.id}`,
                    orgId: u.id,
                    contactId: item.id,
                    rankNum: (_a = u.arank) !== null && _a !== void 0 ? _a : 0,
                    type: 'enterprise',
                    enterpriseId: item.orgId,
                    _lastUpdateTime: lastUpdateTime,
                });
            });
        }
    });
    return { contacts, contactItems, orgContacts };
};
export const transformNewContactList = (list, options) => {
    const contacts = [];
    const contactItems = [];
    const orgContacts = [];
    const ids = new Set();
    list = list.filter(item => {
        if (!!item.id && !ids.has(item.id)) {
            ids.add(item.id);
            return true;
        }
        return false;
    });
    list.forEach(item => {
        contacts.push(transformNewContact2EntityContact(item, options));
        transformNewContact2EntityContactItem(item, options).forEach(ci => contactItems.push(ci));
        transformNewContact2EntityOrgContact(item, options).forEach(oc => orgContacts.push(oc));
    });
    return { contacts, contactItems, orgContacts };
};
export const transformNewUnitList = (list, options) => {
    var _a;
    const allIds = new Set();
    list.forEach(item => {
        if (item.id)
            allIds.add(item.id);
    });
    const mainRoot = list.find(item => item.pid == null || item.pid === '');
    const mainOrgId = (_a = mainRoot === null || mainRoot === void 0 ? void 0 : mainRoot.orgId) !== null && _a !== void 0 ? _a : options.enterpriseId;
    const assocRootIds = new Set();
    list.forEach(item => {
        if (item.pid && !allIds.has(item.pid) && item.orgId !== mainOrgId) {
            assocRootIds.add(item.id);
        }
    });
    const idRewriteMap = new Map();
    if (mainRoot) {
        idRewriteMap.set(mainRoot.id, '-1');
    }
    list.forEach(item => {
        if (assocRootIds.has(item.id)) {
            idRewriteMap.set(item.id, `${item.orgId}_-1`);
        }
    });
    const deduped = new Set();
    list = list.filter(item => {
        if (!!item.id && !deduped.has(item.id)) {
            deduped.add(item.id);
            return true;
        }
        return false;
    });
    return list.map(item => transformNewUnit2EntityOrg(item, Object.assign(Object.assign({}, options), { idRewriteMap, assocRootIds })));
};
export const createEnterpriseRootUnit = (companyId, company) => {
    return {
        qyId: `org_${companyId}`,
        pid: '',
        rank: 0,
        type: 99,
        id: `org_${companyId}`,
        name: company || '',
        orgId: companyId,
    };
};
